{
    "AuthoriseButton_Title": "Autoriser",
    "PreAuthoriseButton_Title": "Autorisation préalable",
    "Authentication_PreAuthorisation_Successful": "Préautorisation",
    "Authentication_Successful": "Autorisation accordée",
    "Authentication_Failed": "Le processus d'autorisation a échoué.",
    "Authentication_Authenticated": "Ce serveur de téléphonie a déjà été autorisé.",
    "Authentication_Status_Title": "Statut d'authentification",
    "Authentication_Status_Warning": "Il y a un avertissement pour cette autorisation, vous pouvez essayer de ré-autoriser pour résoudre ce problème.",
    "Authentication_Status_Warning_Range_30100_30199": "Autorisation réussie, mais un problème de communication avec MS Teams a été détecté. Veuillez contacter le service clientèle d'Akixi.",
    "Authentication_Status_Warning_Range_30200_30299": "Autorisation réussie, mais un problème de synchronisation avec MS Teams a été détecté. Veuillez contacter le service clientèle d'Akixi.",
    "NAME": "OAuthButton"
}